/** @jsx jsx */
import { memo } from 'react';
import { jsx } from '@emotion/react';
import Box from '@atlaskit/ds-explorations/box';
import Text from '@atlaskit/ds-explorations/text';
import { N200 } from '@atlaskit/theme/colors';
import WeekDayGrid from './week-day-grid';
var WeekHeader = /*#__PURE__*/memo(function WeekHeader(_ref) {
  var daysShort = _ref.daysShort;
  return jsx(WeekDayGrid, null, daysShort.map(function (shortDay) {
    return jsx(Box, {
      padding: "space.100",
      display: "block",
      UNSAFE_style: {
        minWidth: 40,
        // Account for languages with short week day names
        whiteSpace: 'nowrap',
        // Account for languages with long week day names
        textAlign: 'center',
        lineHeight: '16px',
        color: "var(--ds-text-subtle, ".concat(N200, ")") // Apply correct fallback to shortDay text
      },

      key: shortDay
    }, jsx(Text, {
      fontWeight: "bold",
      fontSize: "size.050",
      verticalAlign: "middle",
      textTransform: "uppercase"
    }, shortDay));
  }));
});
WeekHeader.displayName = 'WeekHeader';

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default WeekHeader;